import React from "react"
import { graphql } from "gatsby"
import styles from "../styles/global.module.scss"
import convertTokens from "../helpers/convertTokens"
import { useGetTokens } from "../hooks/useGetTokens"
import setSeoData from "../helpers/setSeoData"

// Components
import Layout from "../components/layout/layout"
import Accordion from "../components/common/accordion"
// import MarkdownContent from "../components/content"

export default ({ data, location, accordion }) => {
  const { content } = data

  // Get tokens
  const metadata = useGetTokens()

  let seo_data = setSeoData(content.frontmatter)

  return (
    <Layout location={location} seo_data={seo_data}>
      <div className={styles.container}>
        <h1>{content.frontmatter.title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: convertTokens(content.html, metadata),
          }}
        />
        <Accordion items={content.frontmatter.accordion} />
      </div>
    </Layout>
  )
}
export const query = graphql`
  query {
    content: markdownRemark(frontmatter: { title: { eq: "FAQ" } }) {
      id
      html
      frontmatter {
        title
        meta {
          title
          description
          page_visible
        }
        template
        accordion {
          title
          description
        }
      }
    }
  }
`
